import Head from 'next/head'
import Page from '../../components/Page'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import CommonHeadTags from '../../components/CommonHeadTags'
import {
  GoogleAnalyticsHead,
  GoogleAnalyticsBody,
} from '../../components/GoogleAnalytics'
import useTranslation from '../../translations/useTranslation'
import {
  nonEnglishLocales,
  isLocale,
  locales,
  defaultLocale,
} from '../../translations/config'
import { LocaleProvider } from '../../translations/context'
import pages from '../../routes'

function PageRoute({ locale, page }) {
  const { t } = useTranslation(locale)
  let RenderedPage = null
  let instrument = null

  switch (page) {
    case 'privacy-policy':
      RenderedPage = () => <PrivacyPolicy />
      break
    default:
      if (page.includes('tuning')) {
        instrument = page.split('-tuning')[0]
        RenderedPage = (
          <Page
            instrument={instrument}
            locale={locale}
            instrumentNames={[instrument, 'guitar']}
          />
        )
      } else {
        RenderedPage = <Page instrumentNames={['guitar', 'guitar']} />
      }
  }

  const title = instrument ? t(`title-${instrument}`) : t('description')
  const description = instrument ? t(`description-${instrument}`) : t('description')

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='description' content={description} />
        <meta httpEquiv='content-language' content={locale} />
        {locale === 'en' ? (
          <link rel='canonical' href={`https://guitar-tuner.org/${page}`} />
        ) : (
          <link
            rel='canonical'
            href={`https://guitar-tuner.org/${locale}/${page}`}
          />
        )}
        <link
          rel='alternate'
          hrefLang='x-default'
          href={`https://guitar-tuner.org/${page}`}
        />
        <link
          rel='alternate'
          hrefLang='en'
          href={`https://guitar-tuner.org/${page}`}
        />
        {nonEnglishLocales.map((locale) => (
          <link
            key={locale}
            rel='alternate'
            hrefLang={locale}
            href={`https://guitar-tuner.org/${locale}/${page}`}
          />
        ))}
        <CommonHeadTags />
        <GoogleAnalyticsHead />
      </Head>

      <LocaleProvider lang={locale || defaultLocale}>
        <Header instrument={instrument}/>

        <main>
          {RenderedPage}
        </main>
        <Footer />
      </LocaleProvider>
      <GoogleAnalyticsBody />
    </>
  )
}

export async function getStaticProps(ctx) {
  if (typeof ctx.params.lang !== 'string' || !isLocale(ctx.params.lang)) {
    // in case the value of 'lang' is not a valid locale return it as undefined
    return { props: { locale: undefined, page: ctx.params.page } }
  }

  // the locale is valid
  return { props: { locale: ctx.params.lang, page: ctx.params.page } }
}

export async function getStaticPaths() {
  let paths = []
  locales.forEach((locale) => {
    pages.forEach((page) => {
      paths.push({
        params: { lang: locale, page },
      })
    })
  })

  return {
    paths,
    fallback: false,
  }
}

export default PageRoute
